import GroupStore from '../../stores/productQualityTests/GroupTypeStore';
import { RiskOptionSetting } from './archivemodal/archivemodal.model';
import MeasurementSpecificationTemplatesStore from '../../stores/productQualityTests/MeasurementSpecificationTemplatesStore';
import { PqtConfig } from '../backend/backendapi';

export default class State {
  readonly groupsStore = new GroupStore();
  readonly templatesStore = new MeasurementSpecificationTemplatesStore();
  riskOptionsSetting: RiskOptionSetting = { en: [], de: [] };
  config = new PqtConfig();
}